<template>
  <div class="container index neirong">
    暂时不支持该浏览器，请更换其他浏览器进行访问，推荐搜狗浏览器</br>
    <!-- <a href="http://chrome.cqnhwl.cn/browser.html">
        http://chrome.cqnhwl.cn/browser.html
    </a> -->
  </div>
</template>

<script>
export default {
  components: {},

  watch: {

  },

  mounted() {

  },

  created() {

  },

  methods: {},
};
</script>

<style lang="scss" >
    .neirong{
        text-align: center;
        padding: 50px;
    }
</style>